import React, { useEffect, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import styles from "./NewSingleQueryPopup.module.scss";
import locationIcon from "../../assets/images/location_icon.png";
import destinationIcon from "../../assets/images/experienc_icon.png";
import securityIcon from "../../assets/images/security_icon.png";
import customerIcon from "../../assets/images/customer_icon.png";
import { formatDate, formatIndianCurrency } from "../../utils/utils";

const NewSingleQueryPopup = ({
  setshowRatePopup,
  bookingData,
  noOfNights,
  hotelData,
  ratesData,
  bookingValues,
  selectedAutomaticDiscount,
  selectedDiscount,
  selectedMealPlan,
  commission,
  typeDetail,
}) => {
  const [showRatePopup, setShowRatePopup] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const userType = localStorage.getItem("userType");

  const [isMobile, setIsMobile] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    source: "website",
    content: "",
    source_type: "",
    type: typeDetail ? typeDetail : "package",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleShowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(false);
  };

  const validate = () => {
    const errors = {};
    // Add validation logic for each form field
    // if (currentStep === 1) {
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.company_name.trim()) {
      errors.company_name = "required";
    }
    if (!formData.phone.trim()) {
      errors.phone = "is required";
    }
    if (!formData.querry_detail) {
      errors.querry_detail = "required";
    }
    if (!formData.email) {
      errors.email = "required";
    }
    if (!formData.travel_date) {
      errors.travel_date = "required";
    }
    // }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const checkin = new Date(
      bookingData.checkinYear,
      bookingData.checkinMonth - 1,
      bookingData.checkinDay
    );
    const checkout = new Date(
      bookingData.checkoutYear,
      bookingData.checkoutMonth - 1,
      bookingData.checkoutDay
    );

    const formattedCheckInDate = checkin?.toISOString().split("T")[0];
    const formattedCheckOutDate = checkout?.toISOString().split("T")[0];

    const sourceType =
      userType === "agent"
        ? "agent"
        : userType === "vendor"
        ? "vendor"
        : "customer";

    const rawData = {
      name: formData?.name,
      email: formData?.email,
      phone_information: formData?.phone,
      content: formData?.content,
      source: formData?.source,
      source_type: sourceType,
      type: formData?.type,

      check_in_information: formattedCheckInDate,
      check_out_information: formattedCheckOutDate,
      adults_information: bookingData?.adult ? bookingData?.adult : 2,
      children_information: bookingData?.children ? bookingData?.children : 0,
      child_age_information: bookingData?.childAge ? bookingData?.childAge : [],
      rooms_information: bookingData?.room ? bookingData?.room : 1,
      hotel_category_information: [hotelData?.hotelInfo?.category],
      room_category_information: [hotelData?.hotelInfo?.category],
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/query/create`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(rawData),
          redirect: "follow",
        }
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message || "Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          source: "website",
          content: "",
          source_type: "",
        });
        setshowRatePopup(false);
      } else {
        showErrorToast(
          result.message || "An error occurred. Please try again."
        );
        setFormData({
          name: "",
          email: "",
          phone: "",
          source: "website",
          content: "",
          source_type: "",
        });
      }
    } catch (error) {
      showErrorToast("An error occurred. Please try again.");
      console.error(error);
    }
  };

  const childAgesForPriceBreakup = bookingData?.childAge?.map((age) =>
    parseInt(age, 12)
  );
  const complimentaryChildren = childAgesForPriceBreakup?.filter(
    (age) => age < 6
  ).length;
  const extraChildrenForPricebreakup =
    bookingData?.children - complimentaryChildren;

  return (
    <div className="bg-backdrop">
      <div className={styles.soldout_popup}>
        <div
          className={`${styles.soldout_close_btn} dashboard_checkin_modal_close_btn`}
          onClick={handleShowRatePopup}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path d="M1 12.7464L13 0.851318" strokeWidth="1.2" />
            <path d="M13 12.7463L0.999999 0.851296" strokeWidth="1.2" />
          </svg>
          {/* close */}
        </div>
        <div
          className={`${styles.new_popup_flex} ${styles.soldout_popup_flex}`}
        >
          <div
            className={`${styles.new_popup_colored} ${styles.soldout_room_price}`}
          >
            <div className={styles.center_align}>
              {" "}
              <div className="flex justify_content_between">
                <div className="flex flex_gap_5 align_items_center">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 35 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.9877 24.4166H21.7877V24.3291L16.9752 19.225L17.0043 19.1375H17.296C18.346 19.1375 19.2161 18.8166 19.9064 18.175C20.5967 17.5333 21.0196 16.7847 21.1752 15.9291H22.3418V14.5583H21.146C21.0877 14.2666 20.9856 13.9896 20.8397 13.7271C20.6939 13.4646 20.5141 13.2069 20.3002 12.9541H22.3418V11.5833H12.6585V13.2458H17.2085C17.7141 13.2458 18.1272 13.3722 18.4481 13.625C18.7689 13.8778 18.9877 14.1889 19.1043 14.5583H12.6585V15.9291H19.1335C19.0168 16.318 18.7932 16.6535 18.4627 16.9354C18.1321 17.2173 17.6849 17.3583 17.121 17.3583H14.2043V19.225L18.9877 24.4166ZM17.5002 29.6666C15.8863 29.6666 14.3696 29.3604 12.9502 28.7479C11.5307 28.1354 10.296 27.3041 9.246 26.2541C8.196 25.2041 7.36475 23.9694 6.75225 22.55C6.13975 21.1305 5.8335 19.6139 5.8335 18C5.8335 16.3861 6.13975 14.8694 6.75225 13.45C7.36475 12.0305 8.196 10.7958 9.246 9.74581C10.296 8.69581 11.5307 7.86456 12.9502 7.25206C14.3696 6.63956 15.8863 6.33331 17.5002 6.33331C19.1141 6.33331 20.6307 6.63956 22.0502 7.25206C23.4696 7.86456 24.7043 8.69581 25.7543 9.74581C26.8043 10.7958 27.6356 12.0305 28.2481 13.45C28.8606 14.8694 29.1668 16.3861 29.1668 18C29.1668 19.6139 28.8606 21.1305 28.2481 22.55C27.6356 23.9694 26.8043 25.2041 25.7543 26.2541C24.7043 27.3041 23.4696 28.1354 22.0502 28.7479C20.6307 29.3604 19.1141 29.6666 17.5002 29.6666Z"
                      fill="white"
                    />
                    <circle
                      cx="17.5"
                      cy="18"
                      r="17.5"
                      fill="white"
                      fill-opacity="0.5"
                    />
                  </svg>
                  <h4>Price Breakup</h4>
                </div>

                {isMobile && (
                  <button
                    onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                    className="flex flex_gap_5 align_items_center"
                    style={{ color: "#fff", fontSize: "11px" }}
                  >
                    {isAccordionOpen ? "Hide Breakup" : "View Breakup"}
                    <svg
                      width="10"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transition: "transform 0.3s",
                        margin: "0",
                        transform: isAccordionOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    >
                      <path
                        d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                        stroke="#fff"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </button>
                )}
              </div>
              {(!isMobile || isAccordionOpen) && (
                <div>
                  <div className="flex justify_content_between mt-20">
                    <p>Room Type</p>
                    <span className="room_text-right">
                      {ratesData?.room_name}
                    </span>
                  </div>

                  {(selectedAutomaticDiscount.length > 0 ||
                    selectedDiscount.length > 0) && (
                    <div className="mt-10">
                      <p>
                        Property Discount
                        {selectedAutomaticDiscount?.length > 1 ? "s" : ""}
                      </p>
                      {selectedAutomaticDiscount?.map((discount, index) => (
                        <div
                          className="flex justify_content_between mt-2"
                          key={discount.id}
                        >
                          <span className="discount-name">
                            {discount.promotionName}
                          </span>
                          <span className="room_text-right green">
                            {discount.promotionMode === "percentage"
                              ? `${+discount.promotionAmount}%`
                              : `${formatIndianCurrency(
                                  discount.promotionAmount
                                )}`}
                          </span>
                        </div>
                      ))}

                      {selectedDiscount &&
                        selectedDiscount?.length > 0 &&
                        selectedDiscount?.map((discount, index) => (
                          <div
                            className="flex justify_content_between mt-2"
                            key={discount.id}
                          >
                            <span className="discount-name">
                              {discount.promotionName}
                            </span>
                            <span className="room_text-right green">
                              {discount.promotionMode === "percentage"
                                ? `${+discount.promotionAmount}%`
                                : `${formatIndianCurrency(
                                    discount.promotionAmount
                                  )}`}
                            </span>
                          </div>
                        ))}
                    </div>
                  )}

                  <div className="flex justify_content_between mt-10">
                    <p>
                      Room Rate <small>(Per Night)</small>
                    </p>
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                      }}
                    >
                      {(selectedAutomaticDiscount.length > 0 ||
                        selectedDiscount.length > 0) &&
                        bookingValues.newRoomRate &&
                        bookingValues.roomRateAfterDiscount && (
                          <small
                            style={{
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            {formatIndianCurrency(
                              bookingValues?.roomRatePerNight
                            )}
                          </small>
                        )}

                      {formatIndianCurrency(
                        bookingValues.roomRateAfterDiscount
                          ? bookingValues.roomRateAfterDiscount
                          : bookingValues.newRoomRate
                      )}
                    </span>
                  </div>

                  {(bookingData?.room > 1 || noOfNights > 1) && (
                    <div className="flex justify_content_between mt-10">
                      <p>
                        {noOfNights} Night * {bookingData?.room} Rooms
                      </p>
                      <span className="room_text-right">
                        {formatIndianCurrency(
                          bookingValues.roomRateAfterDiscount *
                            bookingData?.room *
                            noOfNights
                        )}
                      </span>
                    </div>
                  )}

                  {selectedMealPlan?.extra_adult_count > 0 && (
                    <div className="flex justify_content_between mt-10">
                      <p>
                        {selectedMealPlan?.extra_adult_count} Extra Adult{" "}
                        <small>
                          (
                          {formatIndianCurrency(bookingValues?.extraAdultPrice)}{" "}
                          * {noOfNights} Night){" "}
                        </small>{" "}
                      </p>
                      <span className="room_text-right">
                        {formatIndianCurrency(bookingValues?.totalAdultCost)}
                      </span>
                    </div>
                  )}

                  {/* {bookingValues?.childPrices > 0 && (
                                            <div className="flex justify_content_between mt-10">
                                                <p>
                                                    {bookingData.children} Extra Child{" "}
                                                    <small>
                                                        (
                                                        {formatIndianCurrency(
                                                            bookingValues?.childPrices
                                                        )}{" "}
                                                        * {noOfNights} Night){" "}
                                                    </small>{" "}
                                                </p>
                                                <span className="room_text-right">
                                                    {formatIndianCurrency(
                                                        bookingValues?.totalChildAdultCost
                                                    )}
                                                </span>
                                            </div>
                                        )} */}

                  {bookingValues?.childPrices > 0 && (
                    <div className="flex justify_content_between mt-10">
                      <p>
                        {extraChildrenForPricebreakup} Extra Child{" "}
                        <small>
                          {" "}
                          ({formatIndianCurrency(
                            bookingValues?.childPrices
                          )} * {noOfNights} Night){" "}
                        </small>{" "}
                      </p>
                      <span className="room_text-right">
                        {formatIndianCurrency(
                          bookingValues?.totalChildAdultCost
                        )}
                      </span>
                    </div>
                  )}

                  {complimentaryChildren > 0 && (
                    <div className="flex justify_content_between mt-10">
                      <p>{complimentaryChildren} Complimentary Child</p>
                      <span className="room_text-right">Free</span>
                    </div>
                  )}

                  {commission && commission?.commissionAmount && (
                    <div className="flex justify_content_between mt-10">
                      <p>
                        Commission{" "}
                        <small>
                          ({" "}
                          {commission.commissionType === "fixed" ? (
                            <span className="room_text-right">
                              {formatIndianCurrency(
                                commission?.commissionAmount
                              )}
                            </span>
                          ) : (
                            <span className="room_text-right">
                              {commission?.commissionAmount}%
                            </span>
                          )}
                          )
                        </small>
                      </p>
                      {formatIndianCurrency(
                        Number(bookingValues?.calculatedCommissionAmount)
                      )}
                    </div>
                  )}

                  <div className="flex justify_content_between mt-10">
                    <p>Subtotal</p>
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                      }}
                    >
                      {commission &&
                        Object.keys(commission).length > 0 &&
                        bookingValues?.calculatedCommissionAmount && (
                          <small
                            style={{
                              color: "red",
                              textDecoration: "line-through",
                            }}
                          >
                            {formatIndianCurrency(
                              Number(bookingValues?.subtotal) +
                                Number(
                                  bookingValues?.calculatedCommissionAmount
                                )
                            )}
                          </small>
                        )}
                      {formatIndianCurrency(bookingValues?.subtotal)}
                    </span>
                  </div>

                  <div className="flex justify_content_between mt-10">
                    <p>Tax Amount ({bookingValues?.taxSlab}%)</p>
                    <span className="room_text-right">
                      {formatIndianCurrency(bookingValues.taxAmount)}
                    </span>
                  </div>
                </div>
              )}
              <div
                className="flex justify_content_between mt-10"
                style={{ borderTop: "0.5px dashed #fff", paddingTop: "10px" }}
              >
                <h6>Grand Total</h6>
                <h6>{formatIndianCurrency(bookingValues?.grandTotal)}</h6>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className={styles.new_popup_form}>
            <h4
              style={{
                fontSize: "20px",
                fontWeight: "500",
                color: "#333333",
                textAlign: "left",
                marginTop: "10px",
              }}
            >
              Get Your Personalized Hotel Quote Now!
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              <div className="flex flex_gap_10">
                <div style={{ width: "50%" }}>
                  <label htmlFor="name">Name:</label>
                  <input
                    // required
                    className="w-full"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333333",
                      ...(formErrors.name && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                  />
                </div>

                <div style={{ width: "50%" }}>
                  <label htmlFor="phone">Phone:</label>
                  <input
                    className="w-full"
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333333",
                      ...(formErrors.phone && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                  />
                </div>
              </div>
              {/* 
                        <div className="flex flex_gap_10">
                            <div
                                className={
                                    typeDetail === "activity"
                                        ? "activity_inputs_query_forms"
                                        : "w-full"
                                }
                            >
                                <label htmlFor="source_type">Travel Date:</label>
                                <input
                                    className="w-full"
                                    type="date"
                                    name="travel_date"
                                    value={formData.travel_date}
                                    onChange={handleInputChange}
                                    placeholder="Travel Date"
                                    style={{
                                        padding: "10px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        ...(formErrors.travel_date && {
                                            backgroundColor: "#ff000040",
                                            border: "1px solid red",
                                        }),
                                    }}
                                />

                            </div>
                            {typeDetail === "activity" && (
                                <div className="activity_inputs_query_forms">
                                    <label htmlFor="guide_required">Do you need Guide:</label>
                                    <select
                                        style={{
                                            padding: "10px",
                                            ...(formErrors.guide_required && {
                                                backgroundColor: "#ff000040",
                                                border: "1px solid red",
                                            }),
                                        }}
                                        className="w-full"
                                        name="guide_required"
                                        value={formData.guide_required}
                                        onChange={handleInputChange}
                                    >
                                        <option value="" disabled>
                                            Select an option
                                        </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            )}
                        </div> */}

              <div className="flex flex_gap_10">
                <div className="w-full">
                  <label htmlFor="email">Email:</label>
                  <input
                    className="w-full"
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    style={{
                      padding: "5px",
                      borderRadius: "0px",
                      border: "1px solid #333333",
                      ...(formErrors.email && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                  />
                </div>
                {/* <div className="activity_inputs_query_forms">
                                    <label htmlFor="source_type">Are you Agent:</label>
                                    <select
                                        style={{
                                            padding: "5px",
                                            ...(formErrors.source_type && {
                                                backgroundColor: "#ff000040",
                                                border: "1px solid red",
                                            }),
                                        }}
                                        className="w-full"
                                        name="source_type"
                                        value={formData.source_type}
                                        onChange={handleInputChange}
                                    >
                                        <option value="" disabled>
                                            Select an option
                                        </option>
                                        <option value="agent">Yes</option>
                                        <option value="customer">No</option>
                                    </select>
                                </div> */}
              </div>
              {/*  
            {typeDetail === "activity" && (
              <div className="flex flex_gap_10">
                <div className="activity_inputs_query_forms">
                  <label htmlFor="source_type">Adult:</label>
                  <input
                    className="w-full"
                    type="number"
                    name="adult"
                    value={formData.adult}
                    onChange={handleInputChange}
                    placeholder="Adult"
                    style={{
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      ...(formErrors.adult && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                  />
                </div>
                <div className="activity_inputs_query_forms">
                  <label htmlFor="source_type">Time:</label>
                  <input
                    className="w-full"
                    type="time"
                    name="time"
                    value={formData.time}
                    onChange={handleInputChange}
                    placeholder="Time"
                    style={{
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      ...(formErrors.time && {
                        backgroundColor: "#ff000040",
                        border: "1px solid red",
                      }),
                    }}
                  />
                </div>
              </div>
            )} */}

              <div>
                <label htmlFor="content">Query Detail:</label>
                <textarea
                  className="w-full"
                  type="text-area"
                  name="content"
                  value={formData.content}
                  onChange={handleInputChange}
                  placeholder="Querry Detail"
                  style={{
                    padding: "5px",
                    margin: "5px 0",
                    borderRadius: "0px",
                    border: "1px solid #333333",
                    ...(formErrors.content && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }),
                  }}
                />
              </div>
              <div className="">
                <button type="submit" className={styles.common_btn}>
                  Send{" "}
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_8264_9427"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="16"
                      height="17"
                    >
                      <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_8264_9427)">
                      <path d="M10.7832 9.16674H3.33317C3.14428 9.16674 2.98595 9.10285 2.85817 8.97507C2.73039 8.8473 2.6665 8.68896 2.6665 8.50007C2.6665 8.31118 2.73039 8.15285 2.85817 8.02507C2.98595 7.89729 3.14428 7.83341 3.33317 7.83341H10.7832L7.5165 4.56674C7.38317 4.43341 7.31928 4.27785 7.32484 4.10007C7.33039 3.9223 7.39984 3.76674 7.53317 3.63341C7.6665 3.51118 7.82206 3.4473 7.99984 3.44174C8.17762 3.43618 8.33317 3.50007 8.4665 3.63341L12.8665 8.03341C12.9332 8.10007 12.9804 8.1723 13.0082 8.25007C13.0359 8.32785 13.0498 8.41118 13.0498 8.50007C13.0498 8.58896 13.0359 8.6723 13.0082 8.75007C12.9804 8.82785 12.9332 8.90007 12.8665 8.96674L8.4665 13.3667C8.34428 13.489 8.1915 13.5501 8.00817 13.5501C7.82484 13.5501 7.6665 13.489 7.53317 13.3667C7.39984 13.2334 7.33317 13.0751 7.33317 12.8917C7.33317 12.7084 7.39984 12.5501 7.53317 12.4167L10.7832 9.16674Z" />
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewSingleQueryPopup;
